<template>
  <div>
    <CompanyHeader :img_header="header_image" header="รายการจัดการ POS" link_back="managepos"/>
    <MenuCompany/>
    <Set_price_information/>
  </div>
</template>

<script>
import CompanyHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
import MenuCompany from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Set_price_information from "@/components/admin/manage_pos/partner_store_setting/Set_price_information";
export default {
  name: "SetPriceInformation",
  components: {
    Set_price_information,
    MenuCompany,
    CompanyHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
